import './PlacementSummary.scss';

// Friendlier labels for the raw placementType values.
const PLACEMENT_TYPE_LABELS: Record<string, string> = {
  VAST: 'Video VAST',
  Audio: 'Audio VAST',
  Pixel: 'Pixel',
  'Multi-tracker': 'Pixel',
  Display: 'Display',
  HTML: 'Display'
};

interface PlacementSummaryProps {
  network?: string;
  platform?: string;
  placementType?: string;
  length?: string;
  dimensions?: string;
  date?: string;
}

// A compact, read-only summary of the flight/placement context, shown in the tag
// form and the allocation picker so the user can see what they're filtering by
// (and why a creative or placement type is unavailable).
export const PlacementSummary = ({
  network,
  platform,
  placementType,
  length,
  dimensions,
  date
}: PlacementSummaryProps) => {
  const items: { label: string; value: string }[] = [];
  if (network) {
    items.push({ label: 'Network', value: network });
  }
  if (platform) {
    items.push({ label: 'Platform', value: platform });
  }
  if (placementType) {
    items.push({
      label: 'Placement',
      value: PLACEMENT_TYPE_LABELS[placementType] ?? placementType
    });
  }
  if (length) {
    items.push({ label: 'Length', value: `${length}s` });
  }
  if (dimensions) {
    items.push({ label: 'Dimensions', value: dimensions });
  }
  if (date) {
    items.push({ label: 'Flight date', value: date });
  }

  if (items.length === 0) return undefined;

  return (
    <div className='placement-summary'>
      {items.map(item => (
        <div key={item.label} className='placement-summary-item'>
          <span className='placement-summary-label'>{item.label}</span>
          <span className='placement-summary-value'>{item.value}</span>
        </div>
      ))}
    </div>
  );
};
